// Utility function to get provisioning title from catalog list
/**
 * Returns the display name for a given catalog code from a list of catalogs.
 * @param {Array} catalogs - Array of catalog objects.
 * @param {string} code - Catalog code to search for.
 * @returns {string|null} - The display name if found, otherwise null.
 */
function getProvisioningTitle(catalogs, code) {
    if (Array.isArray(catalogs) && catalogs.length) {
        const result = catalogs.find((service) => service.catalogDefinitionId === code);
        return result?.displayName || null;
    }
    return null;
}

export default getProvisioningTitle;
